export default __webpack_public_path__ + "static/media/addresses_main.4ef23329.png";